<template>
  <div class="site-wrap">
    <el-card style="position:relative">
      <el-button
        type="text"
        v-show="activeTab === '0'"
        @click="showTypeDialog"
        style="position:absolute;right:20px;top:20px;z-index:99;"
        v-auth="'storage::out-stock::out_type'"
      >
        {{ $t('storage::out-stock::out_type') }}
      </el-button>
      <el-tabs v-model="activeTab">
        <el-tab-pane :label="item.label" :name="item.name" v-for="(item, index) in tabs" :key="index"></el-tab-pane>
      </el-tabs>
    </el-card>
    <div class="search-wrap">
      <List v-if="activeTab === '0'"></List>
      <Detail v-else-if="activeTab === '1'"></Detail>
    </div>
    <el-dialog :visible.sync="isShowDialog">
      <div slot="title">
        {{ $t('storage::out-stock::out_type') }}
      </div>
      <addType :type="7" v-if="isShowDialog" @closeDialog="isShowDialog = false"></addType>
    </el-dialog>
  </div>
</template>

<script>
import Detail from './detail'
import List from './list'
import addType from '../components/type'
export default {
  components: { Detail, List, addType },
  data() {
    return {
      activeTab: '0',
      tabs: [
        { label: this.$t('storage::out-stock::bill'), name: '0' }
        // { label: '出库明细', name: '1' }
      ],
      isShowDialog: false
    }
  },
  watch: {},
  created() {
    if (this.authPromise('storage::out-stock::check')) {
      this.tabs.push({ label: this.$t('storage::out-stock::out_detail'), name: '1' })
    }
  },
  methods: {
    showTypeDialog() {
      this.isShowDialog = true
    }
  }
}
</script>

<style lang="scss" scoped>
.site-wrap {
  .search-wrap {
    margin-top: -30px;
  }
}
</style>
